"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _UserPanelModule = _interopRequireDefault(require("../styles/components/UserPanel.module.css"));
var _profile = _interopRequireDefault(require("../images/profile.svg"));
var _bellRingingLight = _interopRequireDefault(require("../icons/bell-ringing-light.svg"));
var _bellRinging = _interopRequireDefault(require("../icons/bell-ringing.svg"));
var _world = require("../icons/world");
var _material = require("@mui/material");
var _constants = require("../utils/constants");
var _Wrap = require("../Wrap");
var _functions = require("../utils/functions");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _msalReact = require("@azure/msal-react");
var _user = require("../entities/user");
var _translations = require("../entities/translations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UserPanel = _ref => {
  let {
    theme = _constants.defaultTheme,
    profileImg = null
  } = _ref;
  const isLight = theme === _constants.themeKey.light;
  const [anchorElInfo, setAnchorElInfo] = (0, _react.useState)();
  const [anchorElUser, setAnchorElUser] = (0, _react.useState)();
  const openInfo = Boolean(anchorElInfo);
  const openUser = Boolean(anchorElUser);
  const navigate = (0, _reactRouter.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const methods = (0, _Wrap.useTranslationMethods)();
  const {
    instance
  } = (0, _msalReact.useMsal)();
  const {
    locales = [],
    locale = '',
    setLocale
  } = methods;
  const handleLogout = (0, _react.useCallback)(() => {
    (0, _functions.removeFromLocalStorage)('token');
    instance.logoutRedirect();
    dispatch((0, _user.setTokenAction)(null));
    navigate('/login');
  }, [dispatch]);
  const handleClickInfo = (0, _react.useCallback)(e => setAnchorElInfo(e.currentTarget), []);
  const handleClickUser = (0, _react.useCallback)(e => setAnchorElUser(e.currentTarget), []);
  const handleCloseInfo = (0, _react.useCallback)(() => setAnchorElInfo(null), []);
  const handleCloseUser = (0, _react.useCallback)(() => setAnchorElUser(null), []);
  const changeLang = (0, _react.useCallback)(() => {
    const activeLangIndex = locales.findIndex(l => l.indexOf(locale.slice(0, 2)) === 0);
    const nextLang = activeLangIndex === locales.length - 1 ? locales[0] : locales[activeLangIndex + 1];
    setLocale(nextLang);
  }, [locales, locale, setLocale]);
  const getSX = (0, _react.useCallback)(right => {
    return {
      position: 'relative',
      mt: '9px',
      '&::before': {
        backgroundColor: 'white',
        content: '""',
        display: 'block',
        position: 'absolute',
        width: 14,
        height: 14,
        top: -6,
        transform: 'rotate(45deg)',
        right: right
      }
    };
  }, []);
  const {
    29: logout,
    28: emptyInfo
  } = (0, _reactRedux.useSelector)(_translations.selectActiveTranslationsInterfaceUILocalizations, _functions.areEqual);
  return (0, _react.useMemo)(() => {
    var _locale$slice;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "flex-row ".concat(_UserPanelModule.default.container, " ").concat(_UserPanelModule.default[theme])
    }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
      color: "primary",
      "aria-label": "info-menu",
      className: _UserPanelModule.default.bell,
      component: "label",
      onClick: handleClickInfo
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: isLight ? _bellRingingLight.default : _bellRinging.default,
      alt: "bell"
    })), /*#__PURE__*/_react.default.createElement(_material.Popover, {
      id: 'info-menu',
      open: openInfo,
      anchorEl: anchorElInfo,
      onClose: handleCloseInfo,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      PaperProps: {
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          borderRadius: 0
        }
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: getSX('18px')
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(_UserPanelModule.default.text_container, " ").concat(_UserPanelModule.default.popover_container)
    }, /*#__PURE__*/_react.default.createElement("span", null, emptyInfo !== null && emptyInfo !== void 0 ? emptyInfo : 'No recent notifications.'))), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
      color: "primary",
      variant: "contained",
      className: "".concat(_UserPanelModule.default.language, " ").concat(_UserPanelModule.default[theme]),
      onClick: changeLang
    }, /*#__PURE__*/_react.default.createElement(_world.WorldSVG, {
      stroke: theme === _constants.themeKey.light ? '#666687' : '#f6f6f9'
    }), /*#__PURE__*/_react.default.createElement("span", null, (locale === null || locale === void 0 || (_locale$slice = locale.slice(0, 2)) === null || _locale$slice === void 0 ? void 0 : _locale$slice.toUpperCase()) || '-')), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
      color: "primary",
      "aria-label": "info-menu",
      component: "label",
      "aria-controls": openUser ? 'user-menu' : undefined,
      "aria-haspopup": "true",
      "aria-expanded": openUser ? 'true' : undefined,
      onClick: handleClickUser
    }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
      alt: "Avatar",
      src: profileImg || _profile.default,
      className: _UserPanelModule.default.avatar
    })), /*#__PURE__*/_react.default.createElement(_material.Popover, {
      id: 'user-menu',
      open: openUser,
      anchorEl: anchorElUser,
      onClose: handleCloseUser,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      PaperProps: {
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          borderRadius: 0
        }
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: getSX('17px')
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: _UserPanelModule.default.popover_container
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _UserPanelModule.default.button_container
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      className: "".concat(isLight ? 'btn-secondary' : 'btn-primary', " ").concat(_UserPanelModule.default.btn),
      variant: "text",
      onClick: handleLogout
    }, logout !== null && logout !== void 0 ? logout : 'Logout')))));
  }, [theme, isLight, openInfo, anchorElInfo, locale, openUser, profileImg, anchorElUser, handleLogout, changeLang, handleCloseInfo, handleClickUser, handleCloseUser, getSX, logout, emptyInfo]);
};
var _default = exports.default = UserPanel;